import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signUp } from '../hooks';
import { supabase } from '../../supabase';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
export default function SignupPage() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [company, setCompany] = useState('');
    const [error, setError] = useState(null);
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();
    async function submit(e) {
        e.preventDefault();
        setError(null);
        setBusy(true);
        try {
            const { data, error } = await signUp(email, password);
            if (error)
                throw error;
            if (data.user) {
                await supabase.from('profiles').insert({ id: data.user.id, email, full_name: name });
                if (company.trim()) {
                    const slug = company.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') + '-' + Math.random().toString(36).slice(2, 7);
                    const { data: org } = await supabase.from('organizations').insert({ name: company, slug }).select().single();
                    if (org)
                        await supabase.from('memberships').insert({ org_id: org.id, user_id: data.user.id, role: 'owner' });
                }
            }
            nav('/app/dashboard?welcome=1');
        }
        catch (err) {
            setError(err?.message?.includes('already')
                ? "That email is already in use. Try signing in instead."
                : err?.message ?? 'Could not create the account.');
        }
        finally {
            setBusy(false);
        }
    }
    return (_jsx("main", { id: "main", className: "min-h-dvh grid place-items-center bg-gradient-to-br from-slate-50 to-white px-4 py-12", children: _jsxs("form", { onSubmit: submit, className: "w-full max-w-sm rounded-2xl bg-white p-8 shadow-xl ring-1 ring-slate-200", children: [_jsx("h1", { className: "text-2xl font-semibold tracking-tight text-slate-900", children: "Create your account" }), _jsx("p", { className: "mt-1 text-sm text-slate-500", children: "14-day free trial. No card required." }), _jsxs("div", { className: "mt-6 space-y-4", children: [_jsx(Input, { label: "Your name", autoComplete: "name", value: name, onChange: (e) => setName(e.target.value), required: true }), _jsx(Input, { label: "Work email", autoComplete: "email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), required: true }), _jsx(Input, { label: "Password", autoComplete: "new-password", type: "password", value: password, onChange: (e) => setPassword(e.target.value), required: true, minLength: 8 }), _jsx(Input, { label: "Company name", autoComplete: "organization", value: company, onChange: (e) => setCompany(e.target.value) })] }), error && _jsx("p", { role: "alert", className: "mt-3 text-sm text-red-600", children: error }), _jsx(Button, { type: "submit", disabled: busy, className: "mt-6 w-full", children: busy ? 'Creating…' : 'Create account' }), _jsxs("p", { className: "mt-4 text-center text-sm text-slate-500", children: ["Already have an account? ", _jsx(Link, { to: "/login", className: "font-medium text-brand-700 underline-offset-4 hover:underline", children: "Sign in" })] })] }) }));
}
